import { Tag, TagLabel, TagCloseButton } from "@chakra-ui/react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactSelect from "react-select";
import {
    NodeState,
    selectSelectedCell,
    setCells,
    setNeuralPathWays
} from "../../store/slices/node.slice";

const NeuralPathwaysControlPanel: React.FC = () => {
    // Get memories from the react state
    const nodesDataState: NodeState = useSelector((state: any) => state.nodeData);
    const [pathways, setPathways] = React.useState(nodesDataState.neuralPathWays);

    const selectedCell = useSelector(selectSelectedCell);

    const dispatch = useDispatch();

    const removePathway = (index) => {
        setPathways((currentPathways) => currentPathways.filter((_, i) => i !== index));
        const cells = nodesDataState.cells;

        const updatedCells = cells.map((cell) =>
            cell.unique_identifier === selectedCell?.unique_identifier
                ? { ...cell, pathway: pathways }
                : cell
        );

        dispatch(setCells(updatedCells));
        dispatch(setNeuralPathWays(pathways));
    };

    return (
        <div id="neural-pathway-control-panel" className="agency-control panel-contents">
            <div className="control-panel-header">
                <h1 className="title">Neural Pathways</h1>
                <h2 className="subtitle">Manage the Neural pathways of your cell</h2>
            </div>

            <h2 className="panel-title">Neural Pathways of the Cell</h2>
            <div className="chips-container">
                <div>
                    {pathways.map((pathway, index) => (
                        <Tag
                            size="md"
                            key={index}
                            borderRadius="full"
                            variant="solid"
                            colorScheme="teal"
                            m={1}
                        >
                            <TagLabel>{pathway}</TagLabel>
                            <TagCloseButton onClick={() => removePathway(index)} />
                        </Tag>
                    ))}
                </div>
                <div className="chips">
                    {/*
                                    <div className="pathway-chips chip" data-tool="Open AI 3.5">
                                        Open AI 3.5 <span className="close-btn">×</span>
                                    </div>
                                    <div className="pathway-chips chip" data-tool="Open AI 4">
                                        Open AI 4
                                    <span className="close-btn">×</span>
                                    </div>
                                    <div className="pathway-chips chip" data-tool="Pinecone">
                                        Pinecone
                                    <span className="close-btn">×</span>
                                    </div>
                                */}
                </div>
            </div>

            <h2 className="panel-title">Find Neural Pathways</h2>

            <ReactSelect
                className="react-select-container"
                classNamePrefix="react-select"
                options={[
                    { value: "ALL", label: "All" },
                    { value: "Open AI 3.5", label: "Open AI 3.5" },
                    { value: "Open AI 4", label: "Open AI 4" },
                    { value: "Pinecone", label: "Pinecone" }
                ]}
                styles={{
                    option: (provided) => ({
                        ...provided,
                        color: "black"
                    }),
                    singleValue: (provided) => ({
                        ...provided,
                        color: "black"
                    })
                }}
            />

            <div id="pathways-container" className="pathways-container"></div>
        </div>
    );
};

export default NeuralPathwaysControlPanel;
